export function Bg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1440"
      height="1024"
      fill="none"
      viewBox="0 0 1440 1024"
    >
      <g clipPath="url(#clip0_749_4492)">
        <g filter="url(#filter0_f_749_4492)">
          <ellipse
            cx="719.621"
            cy="-44.873"
            fill="currentcolor"
            fillOpacity="0.32"
            rx="142.749"
            ry="142.749"
            transform="rotate(-90 719.621 -44.873)"
          ></ellipse>
        </g>
        <mask
          id="mask0_749_4492"
          style={{ maskType: "alpha" }}
          width="1157"
          height="691"
          x="142"
          y="-390"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="url(#paint0_radial_749_4492)"
            d="M142 -390H1298.45V300.254H142z"
          ></path>
        </mask>
        <g stroke="#fff" strokeWidth="1.205" mask="url(#mask0_749_4492)">
          <path d="M290.772 -93.058H385.938V2.10799999999999H290.772z"></path>
          <path d="M385.938 -93.058H481.104V2.10799999999999H385.938z"></path>
          <path d="M481.104 -93.058H576.27V2.10799999999999H481.104z"></path>
          <path d="M576.27 -93.058H671.4359999999999V2.10799999999999H576.27z"></path>
          <path d="M671.435 -93.058H766.6009999999999V2.10799999999999H671.435z"></path>
          <path d="M766.601 -93.058H861.767V2.10799999999999H766.601z"></path>
          <path d="M861.767 -93.058H956.933V2.10799999999999H861.767z"></path>
          <path d="M956.933 -93.058H1052.099V2.10799999999999H956.933z"></path>
          <path d="M1052.1 -93.058H1147.2659999999998V2.10799999999999H1052.1z"></path>
          <path d="M290.772 2.107H385.938V97.273H290.772z"></path>
          <path d="M385.938 2.107H481.104V97.273H385.938z"></path>
          <path d="M481.104 2.107H576.27V97.273H481.104z"></path>
          <path
            fill="#fff"
            fillOpacity="0.25"
            d="M576.27 2.107H671.4359999999999V97.273H576.27z"
          ></path>
          <path d="M671.435 2.107H766.6009999999999V97.273H671.435z"></path>
          <path d="M766.601 2.107H861.767V97.273H766.601z"></path>
          <path d="M861.767 2.107H956.933V97.273H861.767z"></path>
          <path d="M956.933 2.107H1052.099V97.273H956.933z"></path>
          <path d="M1052.1 2.107H1147.2659999999998V97.273H1052.1z"></path>
          <path d="M290.772 97.273H385.938V192.439H290.772z"></path>
          <path d="M385.938 97.273H481.104V192.439H385.938z"></path>
          <path d="M481.104 97.273H576.27V192.439H481.104z"></path>
          <path d="M576.27 97.273H671.4359999999999V192.439H576.27z"></path>
          <path d="M671.435 97.273H766.6009999999999V192.439H671.435z"></path>
          <path d="M766.601 97.273H861.767V192.439H766.601z"></path>
          <path d="M861.767 97.273H956.933V192.439H861.767z"></path>
          <path d="M956.933 97.273H1052.099V192.439H956.933z"></path>
          <path d="M1052.1 97.273H1147.2659999999998V192.439H1052.1z"></path>
          <path d="M290.772 192.439H385.938V287.605H290.772z"></path>
          <path d="M385.938 192.439H481.104V287.605H385.938z"></path>
          <path d="M481.104 192.439H576.27V287.605H481.104z"></path>
          <path d="M576.27 192.439H671.4359999999999V287.605H576.27z"></path>
          <path d="M671.435 192.439H766.6009999999999V287.605H671.435z"></path>
          <path d="M766.601 192.439H861.767V287.605H766.601z"></path>
          <path d="M861.767 192.439H956.933V287.605H861.767z"></path>
          <path d="M956.933 192.439H1052.099V287.605H956.933z"></path>
          <path d="M1052.1 192.439H1147.2659999999998V287.605H1052.1z"></path>
        </g>
        <g filter="url(#filter1_f_749_4492)">
          <ellipse
            cx="694.621"
            cy="984.127"
            fill="currentcolor"
            fillOpacity="0.32"
            rx="142.749"
            ry="142.749"
            transform="rotate(-90 694.621 984.127)"
          ></ellipse>
        </g>
        <mask
          id="mask1_749_4492"
          style={{ maskType: "alpha" }}
          width="1157"
          height="691"
          x="117"
          y="639"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="url(#paint1_radial_749_4492)"
            d="M117 639H1273.45V1329.254H117z"
          ></path>
        </mask>
        <g stroke="#fff" strokeWidth="1.205" mask="url(#mask1_749_4492)">
          <path d="M265.772 650.444H360.938V745.6099999999999H265.772z"></path>
          <path d="M360.938 650.444H456.104V745.6099999999999H360.938z"></path>
          <path d="M456.104 650.444H551.27V745.6099999999999H456.104z"></path>
          <path d="M551.27 650.444H646.4359999999999V745.6099999999999H551.27z"></path>
          <path d="M646.435 650.444H741.6009999999999V745.6099999999999H646.435z"></path>
          <path d="M741.601 650.444H836.767V745.6099999999999H741.601z"></path>
          <path
            fill="#fff"
            fillOpacity="0.25"
            d="M836.767 650.444H931.933V745.6099999999999H836.767z"
          ></path>
          <path d="M931.933 650.444H1027.099V745.6099999999999H931.933z"></path>
          <path d="M1027.1 650.444H1122.2659999999998V745.6099999999999H1027.1z"></path>
          <path d="M265.772 745.61H360.938V840.7760000000001H265.772z"></path>
          <path d="M360.938 745.61H456.104V840.7760000000001H360.938z"></path>
          <path d="M456.104 745.61H551.27V840.7760000000001H456.104z"></path>
          <path d="M551.27 745.61H646.4359999999999V840.7760000000001H551.27z"></path>
          <path d="M646.435 745.61H741.6009999999999V840.7760000000001H646.435z"></path>
          <path d="M741.601 745.61H836.767V840.7760000000001H741.601z"></path>
          <path d="M836.767 745.61H931.933V840.7760000000001H836.767z"></path>
          <path d="M931.933 745.61H1027.099V840.7760000000001H931.933z"></path>
          <path d="M1027.1 745.61H1122.2659999999998V840.7760000000001H1027.1z"></path>
          <path d="M265.772 840.776H360.938V935.942H265.772z"></path>
          <path d="M360.938 840.776H456.104V935.942H360.938z"></path>
          <path d="M456.104 840.776H551.27V935.942H456.104z"></path>
          <path d="M551.27 840.776H646.4359999999999V935.942H551.27z"></path>
          <path
            fill="#fff"
            fillOpacity="0.25"
            d="M646.435 840.776H741.6009999999999V935.942H646.435z"
          ></path>
          <path d="M741.601 840.776H836.767V935.942H741.601z"></path>
          <path
            fill="#fff"
            fillOpacity="0.25"
            d="M836.767 840.776H931.933V935.942H836.767z"
          ></path>
          <path d="M931.933 840.776H1027.099V935.942H931.933z"></path>
          <path d="M1027.1 840.776H1122.2659999999998V935.942H1027.1z"></path>
          <path d="M265.772 935.942H360.938V1031.108H265.772z"></path>
          <path d="M360.938 935.941H456.104V1031.107H360.938z"></path>
          <path d="M456.104 935.941H551.27V1031.107H456.104z"></path>
          <path d="M551.27 935.941H646.4359999999999V1031.107H551.27z"></path>
          <path d="M646.435 935.941H741.6009999999999V1031.107H646.435z"></path>
          <path d="M741.601 935.941H836.767V1031.107H741.601z"></path>
          <path d="M836.767 935.941H931.933V1031.107H836.767z"></path>
          <path d="M931.933 935.941H1027.099V1031.107H931.933z"></path>
          <path d="M1027.1 935.941H1122.2659999999998V1031.107H1027.1z"></path>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_749_4492"
          width="767.35"
          height="767.35"
          x="335.946"
          y="-428.548"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_749_4492"
            stdDeviation="120.463"
          ></feGaussianBlur>
        </filter>
        <filter
          id="filter1_f_749_4492"
          width="767.35"
          height="767.35"
          x="310.946"
          y="600.452"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_749_4492"
            stdDeviation="120.463"
          ></feGaussianBlur>
        </filter>
        <radialGradient
          id="paint0_radial_749_4492"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 425.464 -712.819 0 720.223 -44.873)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" stopOpacity="0.2"></stop>
          <stop offset="0.802" stopColor="#D9D9D9" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="paint1_radial_749_4492"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 425.464 -712.819 0 695.223 984.127)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" stopOpacity="0.2"></stop>
          <stop offset="0.802" stopColor="#D9D9D9" stopOpacity="0"></stop>
        </radialGradient>
        <clipPath id="clip0_749_4492">
          <path fill="#fff" d="M0 0H1440V1024H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
